<div
  class="filters"
  cdkDropList
  cdkDropListOrientation="horizontal"
  [cdkDropListConnectedTo]="[deleteArea]"
  cdkDropListLockAxis="x"
  (cdkDropListDropped)="onDropPosFilter($event)">
  <div class="filter-tabs">
    <div *ngFor="let filter of getShowFilters()" class="filter-tab">
      <button
        cdkDrag
        [cdkDragData]="filter"
        class="btn btn-filter btn-filter-neutral dropdown-toggle"
        [ngClass]="{ active: isFilterActive(filter) }"
        [dropdown]="dropdownContent"
        (onDropdownShow)="onShowFilter(filter, dropdownContent)"
        [tooltip]="filter.value ? filter.value : ''"
        tooltipPlacement="bottom">
        {{ filter.title }} <span *ngIf="filter.value">: {{ filter.value }}</span>
      </button>
      <ng-template #dropdownContent let-dr="dropdown">
        <div [ngSwitch]="filter.title" class="dropdown-menu px-0 py-15 rounded-15 bg-neutral-n1">
          <div *ngSwitchCase="'Last active'">
            <div class="date-filter-drop mx-15">
              <input-search-period
                type="date"
                [autoApply]="false"
                (change)="onChangeFilterValue($event.start === null ? '' : $event, filter); dr.hide()"
                [placeholder]="'Date'"></input-search-period>
            </div>
          </div>
          <div *ngSwitchCase="'Phone'">
            <div class="mx-10">
              <h5 class="text-muted">{{ filter.title }}</h5>
              <input
                [(ngModel)]="model.phoneNumbers"
                class="form-control"
                type="text"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Separated by space" />
            </div>
            <hr />
            <div class="d-flex justify-content-end mx-10">
              <button [disabled]="!filter.value" class="btn mr-10" (click)="onChangeFilterValue('', filter); dr.hide()">Clear</button>
              <button class="btn btn-primary" (click)="onChangeFilterValue(model.phoneNumbers, filter); dr.hide()">Submit</button>
            </div>
          </div>
          <div *ngSwitchCase="'User ID'">
            <div class="d-flex flex-column gap-10 mx-10">
              <h5 class="text-muted mb-0">{{ filter.title }}</h5>
              <span class="text-muted">MoneySMS User ID</span>
              <input [(ngModel)]="model.userId" class="form-control" type="text" [ngModelOptions]="{ standalone: true }" />
            </div>
            <hr />
            <div class="d-flex justify-content-end mx-10">
              <button [disabled]="!filter.value" class="btn mr-10" (click)="onChangeFilterValue('', filter); dr.hide()">Clear</button>
              <button class="btn btn-primary" (click)="onChangeFilterValue(model.userId, filter); dr.hide()">Submit</button>
            </div>
          </div>
          <div *ngSwitchCase="'Network'" class="list-filter mx-10">
            <h5 class="text-muted">{{ filter.title }}</h5>
            <div class="filter-input-section d-flex justify-space-between align-items-center py-10">
              <input
                placeholder="Search by destination or network"
                class="form-control"
                [(ngModel)]="networkSearch"
                [ngModelOptions]="{ standalone: true }"
                type="text"
                pm-ignore />
              <span class="icon-search position-absolute"></span>
              <span tooltip="Clear all selected destinations" class="far fa-trash-alt ms-0_8" (click)="onChangeFilterValue('', filter)"></span>
            </div>
            <ul class="list-filter-items">
              <li
                *ngFor="let n of networks | filterText: networkSearch : ['search']"
                (click)="onChangeFilterValue(n, filter)"
                class="d-flex justify-content-start align-items-center">
                <input type="checkbox" class="me-10 form-check-input" [checked]="n.selected" />
                {{ n.country }}({{ n.mcc }})/{{ n.provider }}({{ n.mnc }})
              </li>
            </ul>
          </div>
          <div *ngSwitchCase="'MT Sms'">
            <div class="mx-10">
              <h5 class="text-muted">{{ filter.title }}</h5>
            </div>
            <div class="d-flex mx-10 range-inputs">
              <div class="min-input">
                <label>Min</label>
                <input type="number" [(ngModel)]="model.mtSmsCountMin" class="form-control" [ngModelOptions]="{ standalone: true }" />
              </div>
              <div class="max-input">
                <label>Max</label>
                <input type="number" [(ngModel)]="model.mtSmsCountMax" class="form-control" [ngModelOptions]="{ standalone: true }" />
              </div>
            </div>
            <hr />
            <div class="d-flex justify-content-end mx-10">
              <button [disabled]="!filter.value" class="btn mr-10" (click)="onChangeFilterValue('', filter); dr.hide()">Clear</button>
              <button
                class="btn btn-primary"
                (click)="onChangeFilterValue({ min: model.mtSmsCountMin, max: model.mtSmsCountMax }, filter); dr.hide()">
                Submit
              </button>
            </div>
          </div>
          <div *ngSwitchCase="'Balance'">
            <div class="mx-10">
              <h5 class="text-muted">{{ filter.title }}</h5>
            </div>
            <div class="d-flex mx-10 range-inputs">
              <div class="min-input">
                <label>Min</label>
                <input type="number" step="0.1" [(ngModel)]="model.balanceMin" class="form-control" [ngModelOptions]="{ standalone: true }" />
              </div>
              <div class="max-input">
                <label>Max</label>
                <input type="number" step="0.1" [(ngModel)]="model.balanceMax" class="form-control" [ngModelOptions]="{ standalone: true }" />
              </div>
            </div>
            <hr />
            <div class="d-flex justify-content-end mx-10">
              <button [disabled]="!filter.value" class="btn mr-10" (click)="onChangeFilterValue('', filter); dr.hide()">Clear</button>
              <button class="btn btn-primary" (click)="onChangeFilterValue({ min: model.balanceMin, max: model.balanceMax }, filter); dr.hide()">
                Submit
              </button>
            </div>
          </div>
          <div *ngSwitchCase="'MCC'">
            <div class="mx-10">
              <h5 class="text-muted">{{ filter.title }}</h5>
              <input [(ngModel)]="model.mcc" class="form-control" type="text" [ngModelOptions]="{ standalone: true }" />
            </div>
            <hr />
            <div class="d-flex justify-content-end mx-10">
              <button [disabled]="!filter.value" class="btn mr-10" (click)="onChangeFilterValue('', filter); dr.hide()">Clear</button>
              <button class="btn btn-primary" (click)="onChangeFilterValue(model.mcc, filter); dr.hide()">Submit</button>
            </div>
          </div>
          <div *ngSwitchCase="'MNC'">
            <div class="mx-10">
              <h5 class="text-muted">{{ filter.title }}</h5>
              <input [(ngModel)]="model.mnc" class="form-control" type="text" [ngModelOptions]="{ standalone: true }" />
            </div>
            <hr />
            <div class="d-flex justify-content-end mx-10">
              <button [disabled]="!filter.value" class="btn mr-10" (click)="onChangeFilterValue('', filter); dr.hide()">Clear</button>
              <button class="btn btn-primary" (click)="onChangeFilterValue(model.mnc, filter); dr.hide()">Submit</button>
            </div>
          </div>
          <div *ngSwitchCase="'Original MNC'">
            <div class="mx-10">
              <h5 class="text-muted">{{ filter.title }}</h5>
              <input [(ngModel)]="model.originalMnc" class="form-control" type="text" [ngModelOptions]="{ standalone: true }" />
            </div>
            <hr />
            <div class="d-flex justify-content-end mx-10">
              <button [disabled]="!filter.value" class="btn mr-10" (click)="onChangeFilterValue('', filter); dr.hide()">Clear</button>
              <button class="btn btn-primary" (click)="onChangeFilterValue(model.originalMnc, filter); dr.hide()">Submit</button>
            </div>
          </div>
          <div *ngSwitchCase="'Referral'">
            <div class="mx-10">
              <h5 class="text-muted">{{ filter.title }}</h5>
              <input [(ngModel)]="model.referralCode" class="form-control" type="text" [ngModelOptions]="{ standalone: true }" />
            </div>
            <hr />
            <div class="d-flex justify-content-end mx-10">
              <button [disabled]="!filter.value" class="btn mr-10" (click)="onChangeFilterValue('', filter); dr.hide()">Clear</button>
              <button class="btn btn-primary" (click)="onChangeFilterValue(model.referralCode, filter); dr.hide()">Submit</button>
            </div>
          </div>
          <div *ngSwitchCase="'Referrer'">
            <div class="mx-10">
              <h5 class="text-muted">{{ filter.title }}</h5>
              <input [(ngModel)]="model.referrerCode" class="form-control" type="text" [ngModelOptions]="{ standalone: true }" />
            </div>
            <hr />
            <div class="d-flex justify-content-end mx-10">
              <button [disabled]="!filter.value" class="btn mr-10" (click)="onChangeFilterValue('', filter); dr.hide()">Clear</button>
              <button class="btn btn-primary" (click)="onChangeFilterValue(model.referrerCode, filter); dr.hide()">Submit</button>
            </div>
          </div>
          <div *ngSwitchCase="'Email'">
            <div class="mx-10">
              <h5 class="text-muted">{{ filter.title }}</h5>
              <input [(ngModel)]="model.email" class="form-control" type="text" [ngModelOptions]="{ standalone: true }" />
            </div>
            <hr />
            <div class="d-flex justify-content-end mx-10">
              <button [disabled]="!filter.value" class="btn mr-10" (click)="onChangeFilterValue('', filter); dr.hide()">Clear</button>
              <button class="btn btn-primary" (click)="onChangeFilterValue(model.email, filter); dr.hide()">Submit</button>
            </div>
          </div>

          <div *ngSwitchCase="'Status'">
            <div class="d-flex justify-content-end me-10">
              <span class="cp text-neutral-n7 status-text text-decoration-underline" (click)="onChangeFilterValue('', filter, false)">Clear all</span>
            </div>

            <span class="status-title">MT</span>
            <div
              class="status-list"
              *ngFor="let status of mtStatuses; trackBy: trackByStatusId"
              (click)="$event.stopPropagation(); onChangeFilterValue({ product: 'mt', status: status.id, selected: !status.selected }, filter)">
              <div class="input-check">
                <input class="form-check-input" type="checkbox" [(ngModel)]="status.selected" [ngModelOptions]="{ standalone: true }" />
              </div>
              <span class="icon" [ngClass]="getProductStatusIcon(status.id)"></span>
              <span class="status-text">{{ status.label }}</span>
            </div>
            <br />
            <span class="status-title">MO</span>
            <div
              class="status-list"
              (click)="$event.stopPropagation(); onChangeFilterValue({ product: 'mo', status: status.id, selected: !status.selected }, filter)"
              *ngFor="let status of moStatuses; trackBy: trackByStatusId">
              <div class="input-check">
                <input class="form-check-input" type="checkbox" [(ngModel)]="status.selected" [ngModelOptions]="{ standalone: true }" />
              </div>
              <span class="icon" [ngClass]="getProductStatusIcon(status.id)"></span>
              <span class="status-text">{{ status.label }}</span>
            </div>
            <br />
            <span class="status-title">CLI</span>
            <div
              (click)="$event.stopPropagation(); onChangeFilterValue({ product: 'cli', status: status.id, selected: !status.selected }, filter)"
              class="status-list"
              *ngFor="let status of cliStatuses; trackBy: trackByStatusId">
              <div class="input-check">
                <input class="form-check-input" type="checkbox" [(ngModel)]="status.selected" [ngModelOptions]="{ standalone: true }" />
              </div>
              <span class="icon" [ngClass]="getProductStatusIcon(status.id)"></span>
              <span class="status-text">{{ status.label }}</span>
            </div>
          </div>

          <div *ngSwitchCase="'Payment address'">
            <div class="mx-10">
              <h5 class="text-muted">{{ filter.title }}</h5>
              <input [(ngModel)]="model.paymentAddress" class="form-control" type="text" [ngModelOptions]="{ standalone: true }" />
            </div>
            <hr />
            <div class="d-flex justify-content-end mx-10">
              <button [disabled]="!filter.value" class="btn mr-10" (click)="onChangeFilterValue('', filter); dr.hide()">Clear</button>
              <button class="btn btn-primary" (click)="onChangeFilterValue(model.paymentAddress, filter); dr.hide()">Submit</button>
            </div>
          </div>
          <div *ngSwitchCase="'ID'">
            <div class="d-flex flex-column gap-10 mx-10">
              <h5 class="text-muted">{{ filter.title }}</h5>
              <span class="text-muted">This ID corresponds to phone_info table <br />and is used for debugging purposes</span>
              <input [(ngModel)]="model.id" class="form-control" type="text" [ngModelOptions]="{ standalone: true }" />
            </div>
            <hr />
            <div class="d-flex justify-content-end mx-10">
              <button [disabled]="!filter.value" class="btn mr-10" (click)="onChangeFilterValue('', filter); dr.hide()">Clear</button>
              <button class="btn btn-primary" (click)="onChangeFilterValue(model.id, filter); dr.hide()">Submit</button>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="filter-controls">
    <button class="btn btn-filter filter-add-btn" [disabled]="!getHiddenFilters().length" [dropdown]="hiddenFilters">
      <i class="icon-add"></i> Add Filter
    </button>
    <ng-template #hiddenFilters let-dr="dropdown">
      <ul class="dropdown-menu rounded-15 bg-neutral-n1">
        <li *ngFor="let filter of getHiddenFilters()" class="dropdown-item filter-item px-15 py-10" (click)="onClickShowFilter(filter, dr)">
          <a>{{ filter.title }}</a>
        </li>
      </ul>
    </ng-template>
    <button
      cdkDropList
      cdkDropListLockAxis="x"
      #deleteArea="cdkDropList"
      (cdkDropListDropped)="onDropFilter($event)"
      class="btn btn-filter delete-area"
      (click)="resetFilters()">
      <i class="far fa-trash-alt"></i> Clear
    </button>
    <button class="btn btn-filter btn-filter-primary btn-ts" (click)="onClickTs()"><i class="icon-info-1"></i> Request phone info</button>
  </div>
</div>

<ng-template #phoneInfoModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Request phone info</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body ts-body">
    <div *ngIf="tsLoading" class="spinner">
      <div class="sk-spinner sk-spinner-pulse"></div>
    </div>
    <div class="input-group search-panel rounded-pill">
      <span class="input-group-text"><span class="icon-search"></span></span>
      <input
        type="search"
        class="form-control"
        placeholder="Phone"
        [(ngModel)]="tsPhone"
        [ngModelOptions]="{ standalone: true }"
        (keyup.enter)="onSubmitTs(tsPhone)" />
      <button class="btn btn-primary" type="button" (click)="onSubmitTs(tsPhone)">
        <i class="icon-search"></i>
      </button>
    </div>
    <div *ngIf="!networkInfo && !registrationInfo" class="ts-empty">
      Enter phone number to see:<br />- HLR response details<br />- Network registration info (open/closed) for the phone number’s country
    </div>
    <div *ngIf="networkInfo" class="xconnect-response">
      <div class="xconnect-response__header">
        <h4 class="mb-0">XConnect response</h4>
        <button type="button" class="btn btn-primary" (click)="onUpdatePhoneInfo()" [disabled]="tsUpdateLoading || !canUpdatePhoneInfo()">
          <span *ngIf="tsUpdateLoading" class="spinner-border spinner-border-sm mr-10" role="status" aria-hidden="true"></span>
          Update Phone Info
        </button>
      </div>
      <div *ngIf="tsUpdateSuccessMessage" class="alert alert-success ts-update-message" role="alert">
        {{ tsUpdateSuccessMessage }}
      </div>
      <div *ngIf="tsUpdateErrorMessage" class="alert alert-danger ts-update-message" role="alert">
        {{ tsUpdateErrorMessage }}
      </div>
      <dl class="description-list">
        <dt class="text-muted">Phone</dt>
        <dd>{{ tsPhone === null ? 'N/A' : tsPhone }}</dd>
        <dt class="text-muted">Number Type</dt>
        <dd>{{ networkInfo.numberType === null ? 'N/A' : networkInfo.numberType }}</dd>
        <dt class="text-muted">ISO</dt>
        <dd>{{ networkInfo.country.isoAlpha2 === null ? 'N/A' : networkInfo.country.isoAlpha2 }}</dd>
        <dt class="text-muted">Carrier Name</dt>
        <dd>{{ networkInfo.name === null ? 'N/A' : networkInfo.name }}</dd>
        <dt class="text-muted">MCC</dt>
        <dd>{{ networkInfo.mcc === null ? 'N/A' : networkInfo.mcc }}</dd>
        <dt class="text-muted">MNC</dt>
        <dd>{{ networkInfo.mnc === null ? 'N/A' : networkInfo.mnc }}</dd>
        <dt class="text-muted">Number Portability Dip Indicator</dt>
        <dd>
          <span
            class="icon"
            [ngClass]="{
              'icon-positive text-success': networkInfo.isPorted,
              'icon-negative text-danger': !networkInfo.isPorted,
            }"></span>
          {{ networkInfo.isPorted === null ? 'N/A' : networkInfo.isPorted ? 'Yes' : 'No' }}
        </dd>
        <dt class="text-muted">Number Portability Indicator</dt>
        <dd>
          <span
            class="icon"
            [ngClass]="{
              'icon-positive text-success': networkInfo.isPorted,
              'icon-negative text-danger': !networkInfo.isPorted,
            }"></span>
          {{ networkInfo.isPorted === null ? 'N/A' : networkInfo.isPorted ? 'Yes' : 'No' }}
        </dd>
        <dt class="text-muted">Origin MCC</dt>
        <dd>{{ networkInfo.originalMcc ? networkInfo.originalMcc : 'N/A' }}</dd>
        <dt class="text-muted">Origin MNC</dt>
        <dd>{{ networkInfo.originalMnc ? networkInfo.originalMnc : 'N/A' }}</dd>
        <dt class="text-muted">Origin Carrier Name</dt>
        <dd>{{ networkInfo.originalName ? networkInfo.originalName : 'N/A' }}</dd>
      </dl>
    </div>
    <div *ngIf="liveStatus">
      <div class="registration">
        <h4>Live status</h4>
        <dl class="description-list">
          <dt class="text-muted">Status</dt>
          <dd>{{ liveStatus }}</dd>
        </dl>
      </div>
    </div>
    <div *ngIf="registrationInfo">
      <div class="registration">
        <h4>Registration</h4>
        <dl class="description-list">
          <dt class="text-muted">Network</dt>
          <dd>
            @if (networkInfo) {
              <div [innerHTML]="renderNetworkInfo(networkInfo)"></div>
            } @else {
              -
            }
          </dd>

          <dt class="text-muted">Registration open for this network</dt>
          <dd>
            <span
              class="icon"
              [ngClass]="{
                'icon-positive text-success': registrationInfo.isPhoneNetworkAvailableForRegistration,
                'icon-negative text-danger': !registrationInfo.isPhoneNetworkAvailableForRegistration,
              }"></span>
            {{ registrationInfo.isPhoneNetworkAvailableForRegistration ? 'Yes' : 'No' }}
          </dd>

          <dt class="text-muted">Exists number</dt>
          <dd>
            <span
              class="icon"
              [ngClass]="{
                'icon-positive text-success': registrationInfo.register === true,
                'icon-negative text-danger': registrationInfo.register === false,
              }"></span>
            {{ registrationInfo.register ? 'Yes' : 'No' }}
          </dd>
          <dt class="text-muted">Wait list</dt>
          <dd>
            <span
              class="icon"
              [ngClass]="{
                'icon-positive text-success': registrationInfo.wait === true,
                'icon-negative text-danger': registrationInfo.wait === false,
              }"></span>
            {{ registrationInfo.wait ? 'Yes' : 'No' }}
          </dd>
          <dt class="text-muted">Deleted account</dt>
          <dd>
            <span
              class="icon"
              [ngClass]="{
                'icon-positive text-success': registrationInfo.deleted === true,
                'icon-negative text-danger': registrationInfo.deleted === false,
              }"></span>
            {{ registrationInfo.deleted ? 'Yes' : 'No' }}
          </dd>
        </dl>
      </div>
      <hr />
      <div class="networks">
        <h4>Networks</h4>
        <dl class="description-list">
          <ng-container *ngFor="let network of registrationInfo.networks">
            <dt class="text-muted">Network</dt>
            <dd>{{ network.country }}({{ network.mcc }})/{{ network.provider }}({{ network.mnc }})</dd>
            <dt class="text-muted">Registration</dt>
            <dd>
              <span
                class="icon"
                [ngClass]="{
                  'icon-positive text-success': network.is_available_registration === true,
                  'icon-negative text-danger': network.is_available_registration === false,
                }"></span>
              {{ network.is_available_registration ? 'Yes' : 'No' }}
            </dd>
          </ng-container>
        </dl>
      </div>
    </div>
  </div>
</ng-template>
